import { redirect, RouteObject } from 'react-router';
import PermissionGuard from '../gate/PermissionGuard';
import { PERMISSIONS } from '@/shared/constants';
// import { posPersonalizationRoutes } from './posPersonalizationRoutes';

export const frekuentSpotsRoutes: RouteObject[] = [
	{
		path: 'frekuent-spots',
		children: [
			{
				lazy: async () => {
					const { default: Component } = await import(
						'@/features/frekuent-spots/pages/FrekuentSpotsPage'
					);
					return { Component };
				},
				children: [
					{
						index: true,
						loader: () => redirect('points-of-sale'),
					},
					{
						path: 'points-of-sale',
						lazy: async () => {
							const { default: Page } = await import(
								'@/features/frekuent-spots/list/pages/PointsOfSalePage'
							);
							return {
								Component: () => (
									<PermissionGuard permission={PERMISSIONS.MACHINE_READ}>
										<Page />
									</PermissionGuard>
								),
							};
						},
						children: [
							{
								index: true,
								lazy: async () => {
									const { default: Component } = await import(
										'@/features/frekuent-spots/list/pages/PointsOfSaleOverviewPage'
									);
									return { Component };
								},
							},
							{
								path: 'your-points-of-sales',
								lazy: async () => {
									const { default: Component } = await import(
										'@/legacy/features/pointsOfSale/components/PointOfSaleView'
									);
									return { Component };
								},
							},
							{
								path: 'connectivity',
								lazy: async () => {
									const { default: Component } = await import(
										'@/features/frekuent-spots/list/pages/PointsOfSaleConnectivityPage'
									);
									return { Component };
								},
							},
							{
								path: 'eva-dts',
								lazy: async () => {
									const { default: Page } = await import(
										'@/legacy/features/pointsOfSale/components/EvaDtsView'
									);
									return {
										Component: () => (
											<PermissionGuard permission={[PERMISSIONS.EVA_DTS_READ]}>
												<Page />
											</PermissionGuard>
										),
									};
								},
							},
							{
								path: 'irp',
								lazy: async () => {
									const { IrpPage: Page } = await import('@/features/frekuent-spots/irp');
									return {
										Component: () => (
											<PermissionGuard permission={PERMISSIONS.IRP_READ}>
												<Page />
											</PermissionGuard>
										),
									};
								},
							},
						],
					},
					{
						path: 'points-of-sale/create',
						lazy: async () => {
							const { default: Page } = await import(
								'@/features/frekuent-spots/list/pages/PointsOfSaleCreatePage'
							);
							return {
								Component: () => (
									<PermissionGuard permission={PERMISSIONS.MACHINE_CREATE}>
										<Page />
									</PermissionGuard>
								),
							};
						},
					},
					{
						path: 'points-of-sale/:posId',
						lazy: async () => {
							const { default: Component } = await import(
								'@/features/frekuent-spots/details/pages/PointOfSaleDetailsPage'
							);
							return { Component };
						},
						children: [
							{
								index: true,
								loader: () => redirect('activity'),
							},
							{
								path: 'activity',
								lazy: async () => {
									const { default: Component } = await import(
										'@/features/frekuent-spots/details/pages/PointOFSaleActivityPage'
									);
									return { Component };
								},
								children: [
									{
										index: true,
										lazy: async () => {
											const { default: Component } = await import(
												'@/features/frekuent-spots/details/pages/PointOfSaleActivityIndexPage'
											);
											return { Component };
										},
									},

									{
										path: ':activityId',
										lazy: async () => {
											const { default: Component } = await import(
												'@/features/frekuent-spots/details/pages/PointOfSaleActivityDetailsPage'
											);
											return { Component };
										},
									},
								],
							},
							{
								path: 'planogram',
								lazy: async () => {
									const { default: Page } = await import(
										'@/features/planogram/pages/PlanogramPage'
									);
									return {
										Component: () => (
											<PermissionGuard permission={[PERMISSIONS.PLANOGRAM_READ]}>
												<Page />
											</PermissionGuard>
										),
									};
								},
							},

							{
								path: 'information',
								lazy: async () => {
									const { default: Component } = await import(
										'@/features/frekuent-spots/details/pages/PointOfSaleInfoPage'
									);
									return { Component };
								},
							},
							{
								path: 'configuration',
								lazy: async () => {
									const { default: Page } = await import(
										'@/features/frekuent-spots/master-configuration/pages/MasterConfigPage'
									);
									return {
										Component: () => (
											<PermissionGuard permission={[PERMISSIONS.MASTER_READ]}>
												<Page />
											</PermissionGuard>
										),
									};
								},
							},
							{
								path: 'connectivity',
								lazy: async () => {
									const { default: Component } = await import(
										'@/legacy/features/connetctivity/components/ConnectivityView'
									);
									return { Component };
								},
							},
						],
					},

					// ...posPersonalizationRoutes,

					{
						path: 'products',
						lazy: async () => {
							const { default: Page } = await import('@/features/products/pages/ProductsPage');
							return {
								Component: () => (
									<PermissionGuard permission={PERMISSIONS.PRODUCT_READ}>
										<Page />
									</PermissionGuard>
								),
							};
						},
						children: [
							{
								index: true,
								lazy: async () => {
									const { default: Component } = await import(
										'@/legacy/features/pointsOfSale/components/PointsOfSaleProductsView'
									);
									return { Component };
								},
							},
							{
								path: 'stock',
								lazy: async () => {
									const { default: Component } = await import(
										'@/features/products/pages/StockPage'
									);
									return { Component };
								},
							},
						],
					},
					{
						path: 'products/stock/products-details',
						lazy: async () => {
							const { default: Component } = await import(
								'@/features/products/pages/ProductsDetailsPage'
							);
							return { Component };
						},
					},
				],
			},
		],
	},
];
